import { ProjectExportDataService } from './project-export-data.service';
import { ProjectVO } from '../../../model/vo/project.vo';
import { UserVO } from '@user/model/vo/user.vo';
import { CadFormatVO } from '@article/components/data-center-export/cad-format.vo';
import { SaveCompositeArticleService } from '../../../service/save-composite-article.service';
import { AlertHelper } from '@shared/alert/alert.helper';
import { ProjectModel } from '../../../model/project.model';
import { OverlayBackground } from '@shared/overlay/overlay.type';
import { UserSettings } from '@user/model/user-settings';
import { OverlayService } from '@shared/overlay/overlay.service';
import { Injectable } from '@angular/core';
import { RepresentationService } from '../../../service/representation.service';
import { lastValueFrom } from 'rxjs';
import { Log } from '@shared/debug/log';

@Injectable({ providedIn: 'root' })
export class CadProjectExportService {

  constructor(
    private userSettings: UserSettings,
    private overlayService: OverlayService,
    private projectExportDataService: ProjectExportDataService,
    private alertHelper: AlertHelper,
    private projectModel: ProjectModel,
    private representationService: RepresentationService,
    private saveCompositeArticleService: SaveCompositeArticleService,
  ) { }

  public exportProjectToCad(projectVO: ProjectVO, email: string, userVO: UserVO, cadFormatVO: CadFormatVO): void {
    this.userSettings.setUserSettingValue("selectedCadFormat", cadFormatVO.format);
    this.userSettings.saveUserSettings();
    this.overlayService.requestOverlayShow(OverlayBackground.color);
    this.representationService.scheduleUpdateForCadExport().subscribe(() => {
      this.saveCompositeArticleService.updateCompositeConnectionCorridor(projectVO);
      this.projectExportDataService.exportProjectToCad(projectVO, email, userVO, cadFormatVO).subscribe({
        next: (result) => {
          this.cadExportFinished(result);
          this.clearCorridorInformation();
          this.overlayService.requestOverlayHide(OverlayBackground.color);
        },
        error: (error) => {
          this.showCadExportFailureMessage();
          this.clearCorridorInformation();
          this.overlayService.requestOverlayHide(OverlayBackground.color);
        },
      });
    });
  }

  public async exportProjectWithLabeling(projectVO: ProjectVO, cadFormatVO: CadFormatVO): Promise<void> {
    this.userSettings.setUserSettingValue("selectedCadFormat", cadFormatVO.format);
    this.userSettings.saveUserSettings();

    try {
      const result = await lastValueFrom(this.projectExportDataService.exportProjectToCadWithLabeling(projectVO, cadFormatVO));
      this.cadExportWithLabelingFinished(result);
    } catch (error) {
      Log.error('Error exporting project', error);
      this.showCadExportFailureMessage();
    }
  }

  public cadExportFinished(projectExported: boolean): void {
    if (projectExported) {
      this.alertHelper.showMessage('exportCad.title.export_finished', 'exportCad.message.export_finished');
    } else {
      this.showCadExportFailureMessage();
    }
  }

  public cadExportWithLabelingFinished(projectExported: boolean): void {
    if (projectExported) {
      this.alertHelper.showMessage('exportCad.title.export_with_labeling_finished', 'exportCad.message.export_with_labeling_finished');
    } else {
      this.showCadExportFailureMessage();
    }
  }

  public showCadExportFailureMessage(): void {
    this.alertHelper.showError('exportCad.title.export_failed', 'exportCad.message.export_failed');
  }

  public clearCorridorInformation(): void {
    this.saveCompositeArticleService.clearCompositeConnectionCorridor(this.projectModel.currentProject);
  }
}
